/**
 * A school is a match when the row is tag-based and the school has a filter tag,
 * or when the row is category-based and its category equals the selected concentration.
 * With no selected concentration, every school in a category-based row is a match.
 */
export function isClickPortalResultMatch(
  school: {
    filterTagName?: string | null;
    matchingCategory?: string | null;
  },
  {
    hasTags,
    matchingConcentration,
  }: {
    hasTags?: boolean;
    matchingConcentration?: string | null;
  }
): boolean {
  if (hasTags) {
    return (school?.filterTagName?.length ?? 0) > 0;
  }

  return (
    !matchingConcentration || school.matchingCategory === matchingConcentration
  );
}
